import React from "react";
import BudgetPageContent from "../components/budgetPageContent";

const Budget = () => {
  return <BudgetPageContent />;
};

export default Budget;
